import { render } from "./ProductPriceCalculator.vue?vue&type=template&id=55c7b0e2"
import script from "./ProductPriceCalculator.vue?vue&type=script&lang=js"
export * from "./ProductPriceCalculator.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bomo-staging/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__